import React from 'react';
import { Link } from 'react-router-dom';

const AuthSeparatorLink = ({ textDescription, linkText, toPath }) => {
    return (
        <div className="mt-8">
            <div className="relative flex justify-center text-sm">
                <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-gray-300" />
                <span className="relative z-10 bg-white px-3 text-gray-500 dark:bg-gray-800">
                    Or
                </span>
            </div>
            <p className="text-sm text-center mt-4">
                {textDescription} 
                <Link to={toPath} className="font-medium  hover:underline ">
                    {linkText}
                </Link>
            </p>
        </div>
    );
};

export default AuthSeparatorLink;